import {AddSchema} from "mobx-graphlink";
import {TriggerSet} from "../@TriggerSet.js";
import {Phase} from "../../@Shared/Phase.js";
import {EffectPointer} from "../../@Shared/EffectPointer.js";

export class EngineConfig_Phases {
	constructor(data?: Partial<EngineConfig_Phases>) { Object.assign(this, data); }

	enabled: boolean;

	goPhaseTech_triggerSet: TriggerSet;
	goPhaseDrifting_triggerSet: TriggerSet;
	goPhaseDreaming_triggerSet: TriggerSet;
	goPhaseSolving_triggerSet: TriggerSet;
	goPhaseSolving_duration: number; // in minutes
	goPhaseDelving_triggerSet: TriggerSet;
	stopEnterEffectsWhenPhaseIsLeft: boolean;

	// phase: initial delay
	phaseAfterInitialDelay: Phase;

	// phase: tech
	tech_enterEffect: EffectPointer;
	tech_expire_after: number; // in minutes
	tech_expire_toPhase: Phase;

	// phase: delving
	delving_enterEffect: EffectPointer;
}
AddSchema("EngineConfig_Phases", {
	properties: {
		enabled: {type: "boolean"},
		goPhaseTech_triggerSet: {$ref: "TriggerSet"},
		goPhaseDrifting_triggerSet: {$ref: "TriggerSet"},
		goPhaseDreaming_triggerSet: {$ref: "TriggerSet"},
		goPhaseSolving_triggerSet: {$ref: "TriggerSet"},
		goPhaseSolving_duration: {type: "number"},
		goPhaseDelving_triggerSet: {$ref: "TriggerSet"},
		stopEnterEffectsWhenPhaseIsLeft: {type: "boolean"},

		phaseAfterInitialDelay: {$ref: "Phase"},

		tech_enterEffect: {$ref: "EffectPointer"},
		tech_expire_after: {type: "number"},
		tech_expire_toPhase: {$ref: "Phase"},

		delving_enterEffect: {$ref: "EffectPointer"},
	},
});